import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import Av1 from "../assets/Avatar.png";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div
      name="home"
      className="w-full min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800"
    >
      {/*container*/}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-12 min-h-[calc(100vh-5rem)]">
          {/* Avatar */}
          <div className="flex-shrink-0 order-1 lg:order-1">
            <img
              className="w-48 h-48 sm:w-64 sm:h-64 lg:w-80 lg:h-80 object-cover rounded-full drop-shadow-2xl border-4 border-blue-400/30"
              src={Av1}
              alt="Abraham Molina"
            />
          </div>

          {/* Contenido */}
          <div className="flex flex-col justify-center text-center lg:text-left order-2 lg:order-2 max-w-2xl">
            <p className="text-blue-300 text-base sm:text-lg font-medium mb-3 animate-fade-in">
              Hola, mi nombre es
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white mb-4 tracking-tight">
              Abraham Molina
            </h1>
            <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-blue-300 mb-6 leading-tight">
              Desarrollador Web Full Stack
            </h2>
            <p className="text-slate-300 text-base sm:text-lg leading-relaxed mb-8">
              Especializado en{" "}
              <span className="text-blue-200 font-semibold">
                sistemas de gestión
              </span>{" "}
              con integraciones complejas (AFIP, pagos, autenticación).
              <span className="text-blue-200 font-semibold">2+ años</span>{" "}
              desarrollando soluciones reales para educación y empresas.
            </p>
            <div className="flex justify-center lg:justify-start">
              <Link to="proyectos" smooth={true} duration={500} offset={-80}>
                <button className="text-white border-2 group border-blue-400 bg-blue-600/20 backdrop-blur-sm px-8 py-4 flex items-center hover:bg-blue-600 hover:border-blue-600 transition-all duration-300 rounded-lg font-medium shadow-lg hover:shadow-blue-500/50">
                  Ver proyectos
                  <span className="group-hover:rotate-90 duration-300 ml-3">
                    <HiArrowNarrowRight className="text-xl" />
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
